import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Link as LinkIcon } from 'lucide-react'

export default function OboJwtSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="url"
          label="Token URL"
          icon={<LinkIcon size={16} />}
          value={watch('obo.token_url') || ''}
          onChange={(value) => setValue('obo.token_url', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Audience / Resource"
          value={watch('obo.audience') || ''}
          onChange={(value) => setValue('obo.audience', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="url"
          label="IAS Discovery URL"
          icon={<LinkIcon size={16} />}
          value={watch('obo.issuer_discovery') || ''}
          onChange={(value) => setValue('obo.issuer_discovery', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Resource (optional)"
          value={watch('obo.resource') || ''}
          onChange={(value) => setValue('obo.resource', value)}
          className={styles.input}
        />
      </div>
    </>
  )
}
